"use client";

import { Flex } from "@chakra-ui/react";
import { PolicyLayout } from "../../_components/PolicyLayout";
import { useTranslations } from "next-intl";
import {
  IoInformationCircle,
  IoCloseCircle,
  IoCheckmarkCircle,
  IoList,
  IoTimer,
  IoCut,
  IoGift,
  IoMail,
} from "react-icons/io5";
import { HELP_CENTER_IDS } from "../../_constants/help-center.ids";
import {
  PolicyIntroCard,
  PolicyList,
  PolicySectionCard,
  PolicyText,
} from "../../_components/policy/PolicyContentPrimitives";

export function RefundPolicyContent() {
  const t = useTranslations("landing.policies");

  return (
    <PolicyLayout
      title={t("refund.title")}
      lastUpdated={t("refund.last_updated")}
    >
      <PolicyIntroCard id={HELP_CENTER_IDS.refund.intro}>
        {t("refund.intro")}
      </PolicyIntroCard>

      <Flex id={HELP_CENTER_IDS.refund.sections} direction="column" gap={3}>
        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.refund.section(1)}
          icon={IoInformationCircle}
          number={1}
          sectionTitle={t("refund.nature.heading")}
        >
          <PolicyText>{t("refund.nature.content")}</PolicyText>
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.refund.section(2)}
          icon={IoCloseCircle}
          number={2}
          sectionTitle={t("refund.no_refund.heading")}
        >
          <PolicyText>{t("refund.no_refund.content")}</PolicyText>
          <PolicyList
            items={[
              t("refund.no_refund.item1"),
              t("refund.no_refund.item2"),
              t("refund.no_refund.item3"),
              t("refund.no_refund.item4"),
            ]}
          />
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.refund.section(3)}
          icon={IoCheckmarkCircle}
          number={3}
          sectionTitle={t("refund.exceptions.heading")}
        >
          <PolicyText>{t("refund.exceptions.content")}</PolicyText>
          <PolicyList
            items={[
              t("refund.exceptions.item1"),
              t("refund.exceptions.item2"),
              t("refund.exceptions.item3"),
            ]}
          />
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.refund.section(4)}
          icon={IoList}
          number={4}
          sectionTitle={t("refund.process.heading")}
        >
          <PolicyText>{t("refund.process.content")}</PolicyText>
          <PolicyList
            ordered
            items={[
              t("refund.process.step1"),
              t("refund.process.step2"),
              t("refund.process.step3"),
              t("refund.process.step4"),
            ]}
          />
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.refund.section(5)}
          icon={IoTimer}
          number={5}
          sectionTitle={t("refund.timeline.heading")}
        >
          <PolicyText>{t("refund.timeline.content")}</PolicyText>
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.refund.section(6)}
          icon={IoCut}
          number={6}
          sectionTitle={t("refund.cancellation.heading")}
        >
          <PolicyText>{t("refund.cancellation.content")}</PolicyText>
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.refund.section(7)}
          icon={IoGift}
          number={7}
          sectionTitle={t("refund.free_tier.heading")}
        >
          <PolicyText>{t("refund.free_tier.content")}</PolicyText>
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.refund.section(8)}
          icon={IoMail}
          number={8}
          sectionTitle={t("refund.contact.heading")}
        >
          <PolicyText>{t("refund.contact.content")}</PolicyText>
        </PolicySectionCard>
      </Flex>
    </PolicyLayout>
  );
}
